import { render, staticRenderFns } from "./stockReorder.vue?vue&type=template&id=6946ec52&"
import script from "./stockReorder.vue?vue&type=script&lang=js&"
export * from "./stockReorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports